import get from 'lodash/get';
import FirstStep from '../UserKycComponent/UserKycStepOne';
import { object, array, string, number } from 'yup';
import Aadhar from '../AadharPage/Aadhar';
import PanDetailsPage from '../../UserKyc/UserKycComponent/PanDetailsPage/PanDetailsPage';
import { UserKycVarifyDetails } from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import * as moment from 'moment';
import SuccessPopUP from '../UserPopUP/KYCSuccessPopUp';
import AddressProofFlow from '../UserKycComponent/AddressProofFlow/AddressProofFlow';

let leadName;
export const getLeadName = () => {
  return leadName;
};

let CurrentAdrressFromAadhar;
export const currentAddressFromAAdhar = () => {
  return CurrentAdrressFromAadhar;
};
const Steps = [
  {
    id: 'firstStep',
    component: FirstStep,
    onAction: async (sectionValues, formValues) => {}
  },
  {
    id: 'pan',
    component: PanDetailsPage,
    initialValues: {
      verified: '',
      otherRoute: '',
      file: [],
      imgUrl: [],
      panDetails: {
        fullName: '',
        panNumber: '',
        fatherName: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(moment().format('YYYY') - 18),
          label: String(moment().format('YYYY') - 18)
        }
      }
    },

    validationSchema: object().shape({
      file: array().when('otherRoute', {
        is: false, // alternatively: (val) => val == true
        then: array()
          .required('file is required')
          .of(string().required())
      }),
      imgUrl: string().when('otherRoute', {
        is: false, // alternatively: (val) => val == true
        then: string().required('file is required')
      }),
      panDetails: object().shape({
        fullName: string().required('Required'),
        panNumber: string()
          .length(10, 'must be a 10 digit no')
          .required('Required'),
        fatherName: string().required('Required'),
        date: object().shape({
          value: string().required('Required')
        }),
        month: object().shape({
          value: string().required('Required')
        }),
        year: object().shape({
          value: string().required('Required')
        })
      })
    }),
    onAction: async (sectionValues, formValues) => {
      const leadData = await getApplicantionInfo();
      const doc_id = JSON.parse(localStorage.getItem('doc_id'));
      leadName = sectionValues.panDetails.fullName;
      localStorage.setItem('leadName', JSON.stringify(leadName));
      async function run() {
        try {
          const data = await UserKycVarifyDetails(
            leadData.leadId,
            leadData.leadApplicantId,
            {
              name: sectionValues.panDetails.fullName,
              panNumber: sectionValues.panDetails.panNumber,
              dob:
                sectionValues.panDetails.year.value +
                '-' +
                sectionValues.panDetails.month.value +
                '-' +
                sectionValues.panDetails.date.value,
              fatherName: sectionValues.panDetails.fatherName
            },
            'pan'
          );
          const { verified, message } = data;
          console.log(data);

          if (verified === true) throw new Error('VARIFICATION_SUCCESS');
          else if (verified === false) throw new Error('VARIFICATION_FAILED');
          else throw new Error(data.response.data.message);
        } catch (err) {
          if (err.message === 'VARIFICATION_FAILED')
            throw new Error('VARIFICATION_FAILED');
          else if (err.message === 'VARIFICATION_SUCCESS')
            throw new Error('VARIFICATION_SUCCESS');
          else throw new Error(err.response.data.message);
        }
      }
      if (!sectionValues.verified) {
        await run();
      }
    }
  },
  {
    id: 'UserAadhar',
    component: Aadhar,
    initialValues: {
      file: [],
      imgUrl: [],
      name: '',
      aadhar_no: '',
      address_line_1: '',
      address_line_2: '',
      city: '',
      state: {
        value: '',
        label: 'State'
      },
      pincode: '',
      pincodeCity: '',
      pincodeState: '',
      pincodError: '',
      pinCoderesolved: '',
      date: {
        value: '',
        label: 'Date'
      },
      month: {
        value: '',
        label: 'Month'
      },
      year: {
        value: '2001',
        label: '2001'
      },
      gender: '',
      currentAddress: false,
      PropertyType: false,
      OwnedBy: false,
      monthlyRent: '',
      source: 'Aadhar',
      address: '',
      UploadRent: 3,
      SkipAadhar: false,
      showPreviousImage: '',
      relationShip: {
        label: 'RelationShip',
        value: ''
      },

      firstName: '',
      middleName: '',
      lastName: ''
    },
    validationSchema: object().shape({
      gender: string().when('SkipAadhar', {
        is: false,
        then: string().required('Required')
      }),
      name: string().when('SkipAadhar', {
        is: false,
        then: string()
          .required('Required')
          .min(3, 'Too Short!')
      }),

      aadhar_no: string().when('SkipAadhar', {
        is: false,
        then: string()
          .required('Required')
          .length(12, 'Aadhar shuould be 12 digit Number!')
      }),
      address_line_1: string().when('SkipAadhar', {
        is: false,
        then: string()
          .required('Required')
          .min(10, 'Too Short')
      }),
      city: string().when('SkipAadhar', {
        is: false,
        then: string()
          .required('Required')
          .min('2', 'Too Short!')
      }),
      state: object().shape({
        value: string().when('SkipAadhar', {
          is: false,
          then: string().required('Required')
        })
      }),
      pincode: string().when('SkipAadhar', {
        is: false,
        then: string()
          .required('Required')
          .length(6, 'Must be 6 Digit Nmber!')
      }),
      date: object().shape({
        value: string().when('SkipAadhar', {
          is: false,
          then: string().required('Required')
        })
      }),
      month: object().shape({
        value: string().when('SkipAadhar', {
          is: false,
          then: string().required('Required')
        })
      }),
      year: object().shape({
        value: string().when('SkipAadhar', {
          is: false,
          then: string().required('Required')
        })
      }),
      firstName: string().when('OwnedBy', {
        is: value => value == 'parent' || value == 'family',
        then: string().required('Required')
      }),
      lastName: string().when('OwnedBy', {
        is: value => value == 'parent' || value == 'family',
        then: string().required('Required')
      }),
      relationShip: object().when('OwnedBy', {
        is: value => value == 'parent' || value == 'family',
        then: object().shape({
          value: string().required('required')
        })
      })
    }),

    onAction: (sectionValues, formValues) => {
      if (sectionValues.currentAddress == 'yes') {
        CurrentAdrressFromAadhar = sectionValues.currentAddress;
      }
    }
  },
  {
    id: 'AddressPrrof',
    component: AddressProofFlow,
    initialValues: {
      isValid: currentAddressFromAAdhar,
      UploadRent: 0,
      file: [],
      imgUrl: [],
      PropertyType: false,
      OwnedBy: false,
      monthlyRent: '',
      relationShip: {
        label: 'RelationShip',
        value: ''
      },
      firstName: '',
      middleName: '',
      lastName: '',
      isAddressProofNeed: false
    },
    validationSchema: object().shape({
      relationShip: object().shape({
        value: string().when('isAddressProofNeed', {
          is: true,
          then: string().when('OwnedBy', {
            is: 'parent',
            then: string().required('Required')
          })
        })
      }),
      firstName: string().when('isAddressProofNeed', {
        is: true,
        then: string().required('Required')
      }),
      lastName: string().when('isAddressProofNeed', {
        is: true,
        then: string().required('Required')
      })
    })
  },
  {
    id: 'SuccessPopUP',
    component: SuccessPopUP,
    initialValues: {
      name: getLeadName
    }
  }
];
export default Steps;
